<template>
  <div>
    <div class="form-group">
      <label>Stato</label>
      <br>
      <JqxInput :theme="'material'" name="stato" ref="stato"
                :width="200" :height="25" :source="statoAdapter"
                :valueMember="'nome'" :displayMember="'nome'" @close="onClose($event)" @input="updateTextCountries"
                :minLength="1" :placeHolder="'Inserire lo stato'">
      </JqxInput>
    </div>
    <div class="form-group">
      <label>Località</label>
      <br>
      <JqxInput :theme="'material'" name="localita" ref="localita"
                :width="200" :height="25" :source="localitaAdapter"
                :valueMember="'name'" :displayMember="'display_value'" @select="localitaOnSelect($event)" :minLength="2"
                @input="updateText" :disabled="true" :placeHolder="'Inserire prima lo stato'">
      </JqxInput>
    </div>
    <div class="form-group">
      <label>Cap</label>
      <br>
      <JqxInput :theme="'material'" name="cap" ref="cap"
                :width="200" :height="25" :source="localitaAdapter"
                :valueMember="'name'" :displayMember="'name'" :disabled="true">
      </JqxInput>
    </div>
    <div class="form-group">
      <label>Provincia</label>
      <br>
      <JqxInput :theme="'material'" name="provincia" ref="provincia"
                :width="200" :height="25" :source="localitaAdapter"
                :valueMember="'name'" :displayMember="'name'" :disabled="true">
      </JqxInput>
    </div>
  </div>
</template>
<script>
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";

  export default {
    name: "StatoInput",
    components: {
      JqxInput
    },
    data: function () {
      return {
        statoAdapter: new jqx.dataAdapter(this.statoSource),
        localitaAdapter: new jqx.dataAdapter(this.localitaSource)
      }
    },
    beforeCreate: function () {
      this.statoSource = {
        datatype: 'json',
        datafields: [
          {name: 'nome'},
          {name: 'nome'},
        ],
        //url: '/api/cruds/read?t=' + 'Countries',
      };
      this.localitaSource = {
        dataType: 'json',
        dataFields: [
          {name: 'name'},
          {name: 'postal_code'},
          {name: 'display_value'},
        ],
        //url: '/api/cruds/read?t=' + 'PostalCodes&q=Italia-Tori',
      };
    },
    methods: {
      localitaOnSelect: function (event) {
        let char = this.$refs.localita.val().label.split('-');
        this.$refs.provincia.value = char[2];
        this.$refs.cap.value = char[1];

      }, updateText: function (event) {
        let stato = this.$refs.stato.val();
        let char = this.$refs.localita.val();
        if (char.length == 3) {
          let update = {
            dataType: 'json',
            dataFields: [
              {name: 'name'},
              {name: 'postal_code'},
              {name: 'display_value'},
            ],
            url: '/api/cruds/read?t=' + 'PostalCodes&q=' + stato.value + '-' + char,
          };
          this.$refs.localita.source = new jqx.dataAdapter(update);
        }
      }, updateTextCountries: function (event) {
        let char = this.$refs.stato.val();
        if (typeof char === 'object') {
          char = this.$refs.stato.val().value
        }

        if (char.length == 3) {
          let update = {
            dataType: 'json',
            dataFields: [
              {name: 'nome'},
            ],
            url: '/api/cruds/read?t=' + 'Countries&q=' + char,
          };
          this.$refs.stato.source = new jqx.dataAdapter(update);
        }
      },
      onClose: function (event) {
        this.$refs.localita.disabled = false;
      },
      mounted: function () {
      },
    }
  }
</script>
<style scoped>

  .jqx-popup {
    position: absolute;
    cursor: default;
    z-index: 4000 !important
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/cruddetails/StatoInput.vue